<template lang="html">
  <div class="content" v-loading.fullscreen.lock="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <publish-search :params.sync="params" :showCharts="showCharts" ref="search"/>

    <div class="chart-canvas" ref="historyEchart"></div>

    <div class="report-list-wrap">
      <div class="subType">
        <h4>页面报表</h4>
      </div>
      <el-table
        :data="reportList"
        :default-sort = "{prop: 'key', order: 'ascending'}">
        <el-table-column
          prop="appName"
          label="项目名称"
          sortable>
        </el-table-column>
        <el-table-column
          prop="env"
          label="发布环境"
          sortable>
        </el-table-column>
        <el-table-column
          prop="totalTime"
          label="打包耗时"
          sortable>
          <template slot-scope="scope">
            <span>{{ scope.row.totalTime }}秒</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="buildStartTime"
          label="开始时间">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
  <div>
    <span @click.stop style="padding-right: 10px;">
      <a>发布详情</a>
    </span>
    <span @click.stop>
      <a>发布历史</a>
    </span>
  </div>
</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import qs from "qs";

import publishSearch from "../../components/publish-search";

export default {
  components: {
    publishSearch
  },
  data() {
    return {
      loading: false,

      params: {},
      reportAll: [],
      reportList: []
    };
  },
  methods: {
    async showCharts() {
      this.loading = true;
      // await this.fetchAll();
      this.historyChart = this.historyChart || echarts.init(this.$refs.historyEchart, "light");
      window.addEventListener("resize", () => {
        this.historyChart.resize();
      });

      await this.fetchList();
      const historyData = await this.fetchHistory();
      this.showHistoryChart(historyData);
      this.loading = false;
    },

    showHistoryChart(historyData) {
      const xData = historyData.map(item => {
        return item.buildStartTime;
      });
      const seriesData = historyData.map(item => {
        return item.totalTime;
      });

      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "发布历史（单位：秒）"
        },
        grid: {
          left: 10,
          right: 50,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" + params[i].marker + params[i].seriesName + " : " + params[i].value + "秒" +
                "<br/>" + params[i].marker + '应用' + " : " + historyData[params[i].dataIndex].appName +
                "<br/>" + params[i].marker + '环境' + " : " + historyData[params[i].dataIndex].env;
            }
            return relVal;
          }
        },
        xAxis: {
          type: "category",
          data: xData,
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} 秒"
          }
        },
        legend: {
          data: ["打包耗时"]
        },
        series: [
          {
            name: "打包耗时",
            type: "line",
            data: seriesData,
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'}
              ]
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.historyChart.setOption(option);
    },

    fetchList() {
      const { envId, appName } = this.params;
      const query = {
        env: envId,
        appName: appName
      };

      return axios
        .get(`/publish/list?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;

          this.reportList = data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    fetchHistory() {
      const { envId, appName } = this.params;
      const query = {
        env: envId,
        appName: appName
      };
      return axios
        .get(`/publish/history?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          return data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less">
.light-row {
  color: #ccc;
}
.content {
  padding: 30px;
}
.report-all-wrap {
  margin-top: 30px;
}
.report-list-wrap {
  margin-top: 30px;
}
.mb20 {
  margin-bottom: 20px;
}
.c-danger {
  color: #f56c6c;
}
.c-warning {
  color: #e6a23c;
}
.link {
  word-break: break-all;
}
tr {
  cursor: pointer;
}
.subType {
  margin-bottom: 20px;
  &::after {
    clear: both;
    display: block;
    content: "";
  }
  h4 {
    float: left;
    line-height: 32px;
    margin-right: 20px;
  }
  .el-radio-group {
    float: left;
  }
}
.chart-canvas {
  height: 400px;
  width: 100%;
  margin-top: 30px;
}
.chart-wrap {
  position: relative;
}
</style>
